import { isHideBaseLogsMode, isNodeDevelopment } from '@/app/components/search/utils/envUtils';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const logDevOnly = ({ data, title }: { data: any; title: string }) => {
  if (isNodeDevelopment() && !isHideBaseLogsMode()) {
    const numberSign = '#';
    const numberSignRepeated = numberSign.repeat(28);
    const consoleTitle = `${numberSignRepeated} [${title}] ${numberSignRepeated}`;
    const consoleEnd = numberSign.repeat(consoleTitle.length);

    console.log(`%c ${consoleTitle} `, 'background: #f2007d; color: #fff; border-radius: 4px 4px 0 0');
    console.log(data);
    console.log(`%c ${consoleEnd} `, 'background: #f2007d; color: #fff; border-radius: 0 0 4px 4px');
  }
};

export default logDevOnly;
